






























































import { Component, Vue, Prop } from 'vue-property-decorator';


// Component
import DebugUserIcon from '@/components/common/DebugUserIcon.vue';
// tslint:disable-next-line:no-var-requires
import { TaskComment } from '@/@types/Task';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { vxm } from '@/store';

@Component({
  components: {
    DebugUserIcon,
  },
})
export default class CommentItem extends Vue {
  // コメント
  @Prop({ required: true })
  private comment!: TaskComment | null;
  private taskCommentAttachmentFilesRepository = RepositoryFactory.theoryApi.taskCommentAttachmentFilesRepository();

  private async download(
    taskCommentAttachmentFileId: number,
    attachmentFileName: string,
  ) {
    const param = {
      taskCommentAttachmentFileId: taskCommentAttachmentFileId,
    };
    const projectId = vxm.theoryApi.authStore.getCurrentProjectId;
    const query = {
      'project-id': projectId,
    };
    const signedUrl = (await this.taskCommentAttachmentFilesRepository.taskCommentAttachmentFileDownload(
      param,
      query,
    )).results.signedUrl;
    const downloadLink = document.createElement('a');
    downloadLink.download = attachmentFileName;
    downloadLink.href = signedUrl;
    downloadLink.click();
  }

  private async deleteTaskCommentAttachmentFile(taskCommentAttachmentFileId: number) {
    await vxm.theoryApi.tasksStore.deleteTaskCommentAttachmentFile({
      taskCommentAttachmentId: taskCommentAttachmentFileId,
      projectId: this.projectId,
    });
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }
}
